import React from "react";
import { useBreakpoint } from "@chakra-ui/react";
import client from "../../../../helpers/Client";
import request2APIParams from "../../../../helpers/request2APIParams";
import TaskListTableView from "./TaskListTableView";
import TaskListCardView from "./TaskListCardView";
import { useLoaderData } from "react-router-dom";

export async function TasksLoader({ request }) {
  const params = request2APIParams(request);
  params["page"] = params["page"] || 1;
  const tasks = (await client.get(`/tasks/`, { params })).data;
  return tasks;
}
export default function Task() {
  const bp = useBreakpoint({ ssr: false });
  const tasks = useLoaderData();
  const Component =
    {
      base: TaskListCardView,
      sm: TaskListCardView,
      md: TaskListCardView,
      lg: TaskListTableView,
    }[bp] || TaskListTableView;
  return <Component tasks={tasks} />;
}
